// Dicitura delle pratiche (una riga "impresa" = una pratica), uguale in tutti i menu a tendina.

// Come nelle schede del gestionale: le revisioni compaiono come "Verifica triennale"
export function tipoPratica(richiesta) {
  const t = (richiesta || '').toLowerCase();
  if (t.includes('revis')) return 'Verifica triennale';
  return richiesta || '';
}

// "Pratica" da sola, es. "Iscrizione 1" o "Verifica triennale 2"; vuota se mancano i dati
export function nomePratica(imp) {
  const tipo = tipoPratica(imp?.richiesta);
  const num = imp?.numero_richiesta ? String(imp.numero_richiesta).trim() : '';
  if (!tipo && !num) return '';
  return `${tipo || 'Pratica'} ${num}`.trim();
}

// Testo per i menu a tendina: "RAGIONE SOCIALE — Iscrizione 1"
export function etichettaImpresa(imp) {
  const pratica = nomePratica(imp);
  return pratica ? `${imp.ragione_sociale} — ${pratica}` : imp.ragione_sociale;
}

// Ordina per ragione sociale, poi per tipo di pratica e numero, così le pratiche
// della stessa impresa stanno vicine e in ordine (Iscrizione 1, Iscrizione 2, ...)
export function ordinaPerPratica(imprese) {
  return [...imprese].sort((a, b) =>
    (a.ragione_sociale || '').localeCompare(b.ragione_sociale || '', 'it', { sensitivity: 'base' }) ||
    (a.richiesta || '').toLowerCase().localeCompare((b.richiesta || '').toLowerCase(), 'it') ||
    (parseInt(a.numero_richiesta, 10) || 0) - (parseInt(b.numero_richiesta, 10) || 0)
  );
}
